import React, {Component} from 'react';
import codeThree from "assets/img/code3.PNG";
import codefour from "assets/img/code4.PNG";
import codefive from "assets/img/code5.PNG";
import code from "assets/img/code1.PNG";
import codetwo from "assets/img/code2.PNG";

class DocumentationThree extends Component {
    render() {
        return (
            <div>
                <div>
                    <div className="p-20">
                        <br/>
                        <p>Developer will be able to use our integration environment and set of API
                            collection to develop their app. UAT environment is designed to allow you to build and
                            test app without interfering with a production environment. This integration UAT
                            customized environment and collection can be downloaded from API Documentation
                            page.
                            Download and import user profile (Environment)</p>
                        <br/>
                        <div className="clearfix"></div>
                        <img src={codetwo} alt={codetwo} className="mSpaceLogo" width={'98%'}/>
                        <div className="clearfix"></div>

                        <br/>
                        <blockquote>
                            <small>This will download environment JSON file, now import in Postman application.</small>
                            <small>Open Postman application and click on import button</small>
                        </blockquote>
                    </div>
                </div>
                <div className="">
                    <div className="clearfix"></div>
                    <img src={codeThree} alt={codeThree} className="mSpaceLogo" width={'90%'}/>
                    <div className="clearfix"></div>
                    <br/>
                    <blockquote>
                        <small>Select Import file and choose downloaded <b>(cloudintegration_enviorment.json)</b>  environment JSON file.</small>
                    </blockquote>
                    <div className="clearfix"></div>
                    <img src={codefour} alt={codefour} className="mSpaceLogo" width={'90%'}/>
                    <div className="clearfix"></div>
                    <br/>
                    <blockquote>
                        <small>Now select imported environment. This environment will have variables value
                            of respective merchant.</small>
                    </blockquote>

                </div>
            </div>
        );
    }
}

export default DocumentationThree;